
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index5tc7auHsySOpuXCwf5dmm745FFRkJ_45onuUzFclQsSkcMeta } from "/srv/app/pages/index.vue?macro=true";
import { default as loginN5tDtFqJK5NTdI6alu5LRY78EU0vKOwMv2YFX27VoQ8Meta } from "/srv/app/pages/login.vue?macro=true";
import { default as style_45guideiiVtiwz2opXRxSxRG6Z1wFVJ8TKcAO_yss7UdcQ59NUMeta } from "/srv/app/pages/style-guide.vue?macro=true";
import { default as indexlw9_454zTWZ18XR2Lia5NAfAT3wsBZGamHDhx0kLJU0nUMeta } from "/srv/app/pages/[lang]/index.vue?macro=true";
import { default as indexoBz97HakSPuJEq2c_45StIIoBAqvZmfdNgRMf5itowzOQMeta } from "/srv/app/pages/[lang]/[cinema-slug]/index.vue?macro=true";
import { default as _91page_45slug_93alz66iM_YmmDK6_45sF3AD0bQz2Cji6goI_GvuNeFf7aIMeta } from "/srv/app/pages/[lang]/[cinema-slug]/[page-slug].vue?macro=true";
import { default as indexNlt9smrfHyeUVuGupzcE_45qZSdFI2GFx2IQndl0lWxhEMeta } from "/srv/app/pages/[lang]/[cinema-slug]/filmy/index.vue?macro=true";
import { default as indexs5ZoE_PRn82o4fGLBVywd8Ik_JaCVjXaiFZRDuqgYSEMeta } from "/srv/app/pages/[lang]/[cinema-slug]/[sub-page]/index.vue?macro=true";
import { default as index2ErbzxVS8949lyFemM80hSxa4KHzWxWgC2TrfwlZPNoMeta } from "/srv/app/pages/[lang]/[cinema-slug]/screensaver/index.vue?macro=true";
import { default as indexv81eVmenb1Mutsigq9IonxL7pklpv8iA9oTfGV9iF0AMeta } from "/srv/app/pages/[lang]/[cinema-slug]/akce/[campaign-slug]/index.vue?macro=true";
import { default as indexRVAvM0fxYncuEU_45cfh8PNKNU_45FHxnbsLXijtpmH1DLoMeta } from "/srv/app/pages/[lang]/[cinema-slug]/[sub-page]/[sub2-page]/index.vue?macro=true";
import { default as indexI_45LXY5UH7Exo1G1kh4x8hQQpw7QXdTIsz6sbOYrcyJIMeta } from "/srv/app/pages/[lang]/[cinema-slug]/filmy/movie/[movie-slug]/index.vue?macro=true";
import { default as indexI3fBuU7_45seKFvB6FuTVwp3NLENnYW5p3m8tDiejH52wMeta } from "/srv/app/pages/[lang]/[cinema-slug]/[sub-page]/[sub2-page]/[sub3-page]/index.vue?macro=true";
import { default as component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta } from "/srv/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s } from "/srv/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/srv/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginN5tDtFqJK5NTdI6alu5LRY78EU0vKOwMv2YFX27VoQ8Meta || {},
    component: () => import("/srv/app/pages/login.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/srv/app/pages/style-guide.vue")
  },
  {
    name: "lang",
    path: "/:lang()",
    component: () => import("/srv/app/pages/[lang]/index.vue")
  },
  {
    name: "lang-cinemaslug",
    path: "/:lang()/:cinemaslug()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/index.vue")
  },
  {
    name: "lang-cinemaslug-pageslug",
    path: "/:lang()/:cinemaslug()/:pageslug()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/[page-slug].vue")
  },
  {
    name: "lang-cinemaslug-filmy",
    path: "/:lang()/:cinemaslug()/filmy",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/filmy/index.vue")
  },
  {
    name: "lang-cinemaslug-subpage",
    path: "/:lang()/:cinemaslug()/:subpage()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/[sub-page]/index.vue")
  },
  {
    name: "lang-cinemaslug-screensaver",
    path: "/:lang()/:cinemaslug()/screensaver",
    meta: index2ErbzxVS8949lyFemM80hSxa4KHzWxWgC2TrfwlZPNoMeta || {},
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/screensaver/index.vue")
  },
  {
    name: "lang-cinemaslug-akce-campaignslug",
    path: "/:lang()/:cinemaslug()/akce/:campaignslug()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/akce/[campaign-slug]/index.vue")
  },
  {
    name: "lang-cinemaslug-subpage-sub2page",
    path: "/:lang()/:cinemaslug()/:subpage()/:sub2page()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/[sub-page]/[sub2-page]/index.vue")
  },
  {
    name: "lang-cinemaslug-filmy-movie-movieslug",
    path: "/:lang()/:cinemaslug()/filmy/movie/:movieslug()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/filmy/movie/[movie-slug]/index.vue")
  },
  {
    name: "lang-cinemaslug-subpage-sub2page-sub3page",
    path: "/:lang()/:cinemaslug()/:subpage()/:sub2page()/:sub3page()",
    component: () => import("/srv/app/pages/[lang]/[cinema-slug]/[sub-page]/[sub2-page]/[sub3-page]/index.vue")
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/boleslav-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/budejovice-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/budejoviceIgy-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/hradec-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/jihlava-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/liberec-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/olomouc-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/opava-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/ostrava-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/pardubice-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/plzen-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/praha5-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  },
  {
    name: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6sMeta?.name,
    path: "/praha9-sitemap.xml",
    component: component_45stubWz5fTpqbO_mHRPpHCqal30JKNkOE8cnrOXBrBJhaU6s
  }
]